module.exports = __webpack_public_path__ + "static/emanagement4-d5e4d4d86849497a1ca400271b7a94d7.png";